import { FC, useState } from "react";
import { Stack, useTheme } from "@mui/material";
import {
  FormikSelectField,
  FormikSelectSearchField,
  FormikCheckbox,
  TableToggleField
} from "@vilocnv/allsetra-core";
import DateAndTimeFilters from "../../DateAndTimeFilters/DateAndTimeFilters";
import { FormLabelText, LabelRowBox } from "./InnerForm.styled";
import TimeFilters from "../../TimeFilters/TimeFilters";
import DaysFilters from "../../DaysFilter/DaysFilter";
import { isEmpty } from "lodash";

interface Props {
  groups: Array<any>;
  objectTypes: Array<any>;
  objects: Array<any>;
  keys: Array<any>;
  dataLoading?: boolean;
  translator: any;
  fetchOnDebounce: (value: string) => void;
  onChange?: () => void;
  values: any;
}

const InnerForm: FC<Props> = ({
  groups,
  objectTypes,
  objects,
  keys,
  dataLoading = false,
  translator,
  fetchOnDebounce,
  onChange,
  values
}) => {
  const theme = useTheme();
  const [isSelectDaysAndTimeEnable, setIsSelectDaysAndTimeEnable] =
    useState(false);

  const handleToggleDaysAndTimeChange = (value: boolean) => {
    setIsSelectDaysAndTimeEnable(value);
  };

  const commonFieldProps = {
    fullWidth: true
  };

  console.log("valuesworking", values);
  return (
    <Stack spacing={2}>
      <FormikCheckbox
        theme={theme}
        name="assignedToAllObjects"
        label={translator("selectAllObjects.label", {
          ns: "formFieldsTranslation"
        })}
      />

      {!values.assignedToAllObjects && (
        <>
          <LabelRowBox>
            <FormLabelText>
              {translator("objects.label", { ns: "formFieldsTranslation" })}
            </FormLabelText>
          </LabelRowBox>
          <FormikSelectSearchField
            fetchOnDebounce={fetchOnDebounce}
            // label={translator("objects.label", { ns: "formFieldsTranslation" })}
            placeholder={translator("objects.placeholder", {
              ns: "formFieldsTranslation"
            })}
            name="object"
            options={objects ?? []}
            {...commonFieldProps}
            optionLabelKey="name"
            optionValueKey="uniqueId"
            loading={dataLoading}
            multiple
            searchable
            onChange={onChange}
            sx={{
              marginTop: "0 !important",
              "& .MuiAutocomplete-hasClearIcon.css-1x6bjyf-MuiAutocomplete-root .MuiOutlinedInput-root":
                {
                  paddingRight: "9px"
                }
            }}
            //@ts-ignore
            showStates
            showDropdownIcon
          />
        </>
      )}

      <FormikSelectField
        theme={theme}
        label={translator("objectType.label", { ns: "formFieldsTranslation" })}
        placeholder={translator("objectType.placeholder", {
          ns: "formFieldsTranslation"
        })}
        name="objectType"
        searchable
        {...commonFieldProps}
        options={objectTypes ?? []}
        optionLabelKey="name"
        optionValueKey="uniqueId"
        loading={dataLoading}
        multiple
      />
      {groups?.length ? (
        <FormikSelectField
          theme={theme}
          label={translator("groups.label", { ns: "formFieldsTranslation" })}
          placeholder={translator("groups.placeholder", {
            ns: "formFieldsTranslation"
          })}
          name="group"
          {...commonFieldProps}
          options={groups ?? []}
          optionLabelKey="name"
          optionValueKey="uniqueId"
          loading={dataLoading}
          multiple
          searchable
        />
      ) : (
        <></>
      )}

      {!isEmpty(keys) && (
        <FormikSelectField
          theme={theme}
          {...commonFieldProps}
          label={translator("keys.label", { ns: "formFieldsTranslation" })}
          placeholder={translator("keys.placeholder", {
            ns: "formFieldsTranslation"
          })}
          name="key"
          options={keys ?? []}
          optionLabelKey="label"
          optionValueKey="uniqueId"
          loading={dataLoading}
          multiple
          searchable
        />
      )}

      <TableToggleField
        label={translator("common.selectDaysAndTime") ?? "Select days and time"}
        name="selectDaysAndTime"
        onChange={(e) => handleToggleDaysAndTimeChange(e.target.checked)}
        checked={isSelectDaysAndTimeEnable}
      />

      {isSelectDaysAndTimeEnable && (
        <>
          <DaysFilters values={values} />

          <TimeFilters values={values} />
        </>
      )}
    </Stack>
  );
};

export default InnerForm;
